import { Component} from '@angular/core';
import { ContractStepModel, ContractWrapperModel, PaymentTransactionModel_Opt } from '../../../../models/contract.model';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertService } from '../../../../services/notify/alert.service';
import { ContractDataService } from '../../services/contract-data.service';
import { FileDataResponse } from '../../../../services/api/documents-api.service';
import { ITaskTargetResponse, TaskModel } from '../../../../models/task.model';
import { ICreditLetter, IMultiPaymentStateCS } from '../../../../models/finance.model';
import { ContractRoadMapService } from '../../services/contract-roadmap.service';

@Component({
    selector: 'app-contract-step-target-select',
    templateUrl: './contract-step-target-select.component.html',
    styleUrl: './contract-step-target-select.component.scss',
 
})
export class AppContractStepTargetSelectComponent {
  public roadmap!:ContractStepModel[];
  public step!:ContractStepModel;
  public contractGuid!:string;
  public currentTargetData:FileDataResponse | ITaskTargetResponse | ContractWrapperModel | IMultiPaymentStateCS | ICreditLetter | PaymentTransactionModel_Opt | undefined
  public targetItem:any;
  public dialogToClose!:MatDialogRef<any>;
  constructor (
    public contractRoadMapService:ContractRoadMapService,
    public contractDataService:ContractDataService,
    public alertService:AlertService,
  ) {}
  ngOnInit(): void {
   this.currentTargetData =  this.contractDataService.getCachedStepTargetData(this.step)
  }
  onItemSelected(data:any) {
    this.targetItem = data
  }
  onSubmitSelected (taskData?:TaskModel) {
    taskData? this.targetItem = taskData : null;
    if (this.targetItem) {
      this.contractRoadMapService.onSaveStep(this.roadmap||[], this.step, this.targetItem,this.contractGuid)
      this.dialogToClose? this.dialogToClose.close() : null
    } else {
      this.alertService.setAlert('Ошибка при выборе объекта','blue')
    }
  }
}
